__turbopack_context__.v({
  "primary": "landing-button-module__W8uqtW__primary",
  "tertiary": "landing-button-module__W8uqtW__tertiary",
});
